var map = {
	"./A.svg": "0112",
	"./B.svg": "8628",
	"./C.svg": "3fbf",
	"./D.svg": "f149",
	"./E.svg": "401c",
	"./F.svg": "cce5",
	"./G.svg": "761c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";